import * as React from "react";

function SvgBack(props) {
  return <svg fill="none" viewBox="0 0 28 28" {...props}><path fill="currentColor" opacity={0.15} d="M11.9 3.19a.96.96 0 011.4.02 17 17 0 010 22.58.96.96 0 01-1.4.02L1.3 15.21a1 1 0 010-1.42L11.9 3.2z" /><path fill="currentColor" d="M16.85 3.15c.2.2.2.5 0 .7L6.71 14H26.5a.5.5 0 010 1H6.7l10.15 10.15a.5.5 0 01-.7.7L5.85 15.56a1.5 1.5 0 010-2.12l10.3-10.3c.2-.19.5-.19.7 0z" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/back_6e3471.svg";
export { SvgBack as ReactComponent };